module.exports = __webpack_public_path__ + "static/media/paying-for-order.53ccf17c.jpg";